/**
 * Centralized INR Currency Formatter Utility for All Home Desire
 * Converts raw numerical values or price strings into clean Indian numbering representations (Cr / Lac / formatted number).
 * Preserves decimal accuracy and handles fallback values gracefully.
 *
 * @param {number|string} amount
 * @returns {string} Formatted INR price string (e.g., "₹ 2.85 Cr", "₹ 75 Lac", "₹ 45,000", "Price on Request")
 */
export const formatPriceInr = (amount) => {
  if (amount === undefined || amount === null || amount === "") {
    return "Price on Request";
  }

  const num = typeof amount === "number" ? amount : parseFloat(String(amount).replace(/[^0-9.]/g, ""));

  if (isNaN(num) || num <= 0) {
    return typeof amount === "string" && amount.trim().length > 0 && isNaN(Number(amount))
      ? amount
      : "Price on Request";
  }

  // Crores (>= 1 Crore = 10,000,000)
  if (num >= 10000000) {
    const cr = (num / 10000000).toFixed(2).replace(/\.00$/, "");
    return `₹ ${cr} Cr`;
  }

  // Lakhs (>= 1 Lakh = 100,000)
  if (num >= 100000) {
    const lac = (num / 100000).toFixed(2).replace(/\.00$/, "");
    return `₹ ${lac} Lac`;
  }

  // Thousands and below
  return `₹ ${num.toLocaleString("en-IN")}`;
};

export default formatPriceInr;
